<template>
    <div class = "container">
       
        <div class="tableDiv">
            <div class="timeDiv">
            年份：<el-date-picker  v-model="sbsj" type="year"  value-format="yyyy" placeholder="选择年份"> </el-date-picker></div>
            <div class="titleDiv"><span>{{ this.sbsj}}年各大队个税计算清缴申报工作项目考评(5分)</span></div>
            <el-table :data="data" border highlight-current-row style="width: 49%">
                <el-table-column v-if="hideIdColumn" prop="id" label="ID"></el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        width="50"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="bmmc"
                        label="大队"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="ysbrs"
                        label="应申报人数"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.ysbrs" placeholder="请输入正整数" maxlength="6" :value="0" @input="calculateResult(scope.row)" oninput="value = Number(value) || 0"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="wcrs"
                        label="完成人数"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.wcrs"  placeholder="请输入正整数" maxlength="6" :value="0" @input="calculateResult(scope.row)" oninput="value = Number(value) || 0"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="wcl"
                        label="完成率"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{ scope.row.wcl }}%
                    </template>
                </el-table-column>
                <el-table-column
                        prop="df"
                        label="得分"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                       {{ scope.row.df }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div >
            
                <el-button type="primary" round class="floating-button1" :disabled="handleSaveButton" @click="handleSave">保存</el-button>
              
                <el-button type="primary" round class="floating-button2" :disabled="releaseButton" @click="release">发布</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                data: [{ id: '', bmmc: '', ysbrs: 0, wcrs: 0, wcl: 0 ,df:''}],
                sbsj: '',
                showAlert: false,
                currentDate: new Date(),
                hideIdColumn :false,
                handleSaveButton: false,
                releaseButton: false,
                rawData:[]
            }
        },
        computed: {
           
        },
      
        created(){
            // this.getDate();
            this.isRepeat()
        
        },
        methods: {
            getDate() {
                // 获取时间
                const nowDate = new Date();
                // 分别获取年、月
                const date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth(),
                };
                if(date.month === 0){
                    date = {
                        year: nowDate.getFullYear() -1,
                        month : 12
                    }
                }
                // 月份为单数时十位显示0
                const newMonth = date.month >= 10 ? date.month : "0" + date.month;

                // 返回格式为yyyymm的年月
                this.sbsj =  date.year +'-'+ newMonth.toString();
            },
            //获取部门数据
            getDepts() {
                this.$request({
                    method: 'get',
                    url: '/bjba/khxx/xjxx/findDdData'
                }).then((response)=>{
                    if(response.data.code === 200){
                        this.rawData = response.data.data 
                        this.processData()            
                    }
                }).catch((err)=>{
                    console.log(err)
                });
                
            },
            processData() {
                this.data = this.rawData.map(item => {
                    let newItem = {};
                    for (let key in item) {
                    if (item.hasOwnProperty(key)) {
                        newItem[key.toLowerCase()] = item[key];
                    }
                    }
                    return newItem;
                });
            },
            //是否已经填报，已填未发布 则进入修改操作
            isRepeat(){
                this.$request.get('/bjba/khxx/gssb/isRepeat',{
                    params: {bbsj:this.sbsj}
                }).then(res => {
                    if(res.data.code === 200){
                        if(res.data.data === undefined){
                            this.handleSaveButton = true
                                this.releaseButton = true
                            this.$message({
                                    message: res.data.message,
                                    type: 'success',
                                    duration: 1500
                                })
                                
                        }else{
                            this.data = res.data.data
                        }
                    
                    }else {
                        //获取部门数据
                        this.getDepts();
                    }
                })
            },
            //保存
            handleSave() {
                if(this.sbsj == '' || this.sbsj==undefined){
                    this.$message({
                                    message: '请选择时间',
                                    type: 'error',
                                    duration: 1500
                                })
                    return 
                }
                console.log('data=====',this.data)
                this.data[0].bbjs =  this.sbsj
                this.$http({
                            url: `/bjba/khxx/gssb/saveGssb`,
                            method: 'post',
                            data: this.data
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                this.$message({
                                    message: data.message,
                                    type: 'success',
                                    duration: 1500
                                })
                            } else {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })
            },
            // 发布
            release() {
                if(this.sbsj == '' || this.sbsj==undefined){
                    this.$message({
                                    message: '请选择时间',
                                    type: 'error',
                                    duration: 1500
                                })
                    return 
                }
                this.$confirm('是否已保存？需先保存后发布，发布后不可更改')
                .then(_ => {
                    this.$request.get('/bjba/khxx/gssb/release',{
                        params: {bbsj:this.sbsj}
                    }).then(res => {
                        if(res.data.code === 200){
                            this.handleSaveButton = true
                            this.releaseButton = true
                            this.$message({
                                    message: res.data.message,
                                    type: 'success',
                                    duration: 1500
                                })
                        }else {
                            this.$message({
                                    message: res.data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                        }
                    })
                })
                .catch(_ => {});

            },
            //计算保留两位小数
            calculateResult(row) {
               if (row.ysbrs === 0 || row.ysbrs === undefined || row.wcrs === undefined || row.wcrs === 0 ) {
                    row.wcl = '0.00';
                } else if(Number.isNaN(row.wcrs / row.ysbrs)){
                    row.wcl = '0.00';
                }else{ 
                    row.wcl = ((row.wcrs / row.ysbrs) * 100).toFixed(2);
                }
                if(row.wcl === 0 || row.wcl < 95){
                    row.df = 0
                }else if(row.wcl >= 95 && row.wcl < 100){
                    row.df = 3
                }else if(row.wcl >= 100){
                    row.df = 5
                }else{
                    row.df = 0
                }
            }
        }
    };
</script>
<style scoped>
    body, html {
    height: 100%;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    }
    
    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .tableDiv {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .titleDiv {
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: bold;
    }
    el-table {
        width: 100%;
    }
    .is-invalid .el-input__inner {
        border-color: red !important;
    }
    .floating-button1 {
        position: fixed;
        bottom: 100px; /* 距离底部20px */
        right: 15%;  /* 距离右侧20px */
        padding: 10px 20px;
        background-color: #8bc516;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        z-index: 1000; /* 确保按钮在所有内容之上 */
    }
    .floating-button1:hover {
        background-color: #0056b3;
    }
    .floating-button2 {
        position: fixed;
        bottom: 50px; /* 距离底部20px */
        right: 15%;  /* 距离右侧20px */
        padding: 10px 20px;
        background-color: #1482b5;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        z-index: 1000; /* 确保按钮在所有内容之上 */
    }
    .floating-button2:hover {
        background-color: #0e90ad;
    }
    .timeDiv{
        /* margin-left: 50px; 
        
        padding: 10px; */
        margin-top: 20px;
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: bold;
        /* background-color: rgb(52, 178, 227); */
    }

</style>